import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { Link } from 'react-router-dom';

const subPages = [
  { icon: 'ri-layout-5-line', title: '五层平台架构', desc: '用户 · 场景 · 交易 · 基础设施 · 治理', href: '/jiuchou/architecture' },
  { icon: 'ri-flow-chart', title: '一条业务主链', desc: '从一件商品开始，跑通消费到产业闭环', href: '/jiuchou/chain' },
  { icon: 'ri-user-heart-line', title: '数字商业节点', desc: '云社员 · 云店，人人都能成为数字节点', href: '/jiuchou/yun-node' },
  { icon: 'ri-truck-line', title: '供应链与服务', desc: '从卖商品到卖服务，农产品数字化上行', href: '/jiuchou/supply-service' },
  { icon: 'ri-restaurant-2-line', title: '消费与权益', desc: '聚餐场景 · 权益系统，消费端样板', href: '/jiuchou/consumption' },
  { icon: 'ri-file-list-3-line', title: '透明清分账本', desc: '每一笔价值，都有记录', href: '/jiuchou/settlement' },
  { icon: 'ri-brain-line', title: '数据飞轮与 AI', desc: '数据闭环 · TOMA AI · AI 应用服务商', href: '/jiuchou/data-ai' },
  { icon: 'ri-magic-line', title: '体验九畴云铺', desc: '五角色模拟运营，亲自体验项目', href: '/experience' },
];

export default function Directory() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="产品架构全景"
            title="九畴云铺 · 栏目导览"
            subtitle="九畴云铺不是「一个商城」，而是一套完整的县域数字商业基础设施。以下栏目带你从架构、主链、业务闭环到 AI 与体验，逐步深入。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {subPages.map((s, i) => (
            <Reveal key={s.href} delay={i * 60}>
              <Link
                to={s.href}
                className="group h-full p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors flex flex-col cursor-pointer"
              >
                <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className={`${s.icon} text-primary-600 text-xl`}></i>
                </div>
                <h3 className="mt-3 font-heading font-bold text-foreground-950 text-base group-hover:text-primary-600 transition-colors">
                  {s.title}
                </h3>
                <p className="mt-1 text-sm text-foreground-500 leading-relaxed flex-1">{s.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                  查看
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}